"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpStorage = require("@ua/help-storage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var API_HOST = 'origin-help';
var ENV_PREFIXES = {
  dev: 'dev-',
  development: 'dev-',
  local: 'dev-',
  prod: '',
  production: '',
  test: 'test-'
};
var LOCALSTORAGE_KEY_ACTIVATED = 'help-loader-activated';
var LOCALSTORAGE_KEY_EXPIRES = 'help-loader-expires';
var SCRIPT_ID = 'help-loader-script';
var SCRIPT_ID_CHICLET = 'help-loader-chiclet';
var TAB_CONTACT = 'contact';
var expirationTimeMillis = 1000 * 60 * 60 * 24; // 24 hour storage expiry

var getApiEndpoint = function getApiEndpoint(_ref) {
  var _ref$chiclet = _ref.chiclet,
      chiclet = _ref$chiclet === void 0 ? false : _ref$chiclet,
      env = _ref.env;
  var envPrefix = ENV_PREFIXES[env];
  var PATHNAME = 'helpContainerBundle';
  var apiEndPoint = "https://".concat(API_HOST, ".").concat(envPrefix, "godaddy.com/").concat(PATHNAME);

  if (window && window.ux && !window.ux.versions) {
    // Consumer is running Uxcore1, serve them bundle with uxcore2 included
    apiEndPoint = "".concat(apiEndPoint, "Uxcore2");
  }

  if (chiclet) {
    apiEndPoint = "".concat(apiEndPoint, "Chiclet");
  }

  apiEndPoint = "".concat(apiEndPoint, "?t=").concat(Date.now()); // return `http://localhost:8080/${PATHNAME}`; // for local development (help-api local)

  return apiEndPoint;
};

var Spinner = _react.default.createElement("div", {
  className: "help--spinner-container"
}, _react.default.createElement("div", {
  className: "help--spinner-box"
}, _react.default.createElement("div", {
  className: "help--spinner"
})), _react.default.createElement("style", {
  dangerouslySetInnerHTML: {
    __html: "\n  .help--spinner-container {\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.5);\n    display: flex;\n    height: 100vh;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 9999;\n  }\n  .help--spinner-box {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    background-color: #FFFFFF;\n    height: 80px;\n    width: 80px;\n    border: 1px solid #D3D3D3;\n    border-radius: 10px;\n  }\n  .help--spinner {\n    animation: help--rotation .6s infinite linear;\n    border: 6px solid rgba(0, 0, 0, 0.15);\n    border-radius: 100%;\n    border-top: 6px solid rgba(0, 0, 0, 0.8);\n    height: 50px;\n    width: 50px;\n  }\n\n  @keyframes help--rotation {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n"
  }
}));

var HelpLoader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HelpLoader, _PureComponent);

  function HelpLoader(props) {
    var _this;

    _classCallCheck(this, HelpLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HelpLoader).call(this, props));
    _this.fetchAndExecuteBundle = _this.fetchAndExecuteBundle.bind(_assertThisInitialized(_this));
    _this.fetchAndExecuteBundleChiclet = _this.fetchAndExecuteBundleChiclet.bind(_assertThisInitialized(_this));
    _this.state = {
      error: false,
      loaded: false,
      loadedChiclet: false,
      loading: false,
      shouldReactivate: false,
      affordanceOverride: false,
      calledByChiclet: false
    };
    return _this;
  }

  _createClass(HelpLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          activated = _this$props.activated,
          env = _this$props.env,
          affordance = _this$props.affordance;
      if (affordance) this.fetchAndExecuteBundleChiclet();
      (0, _helpStorage.initialize)({
        env: env
      }).then(function () {
        (0, _helpStorage.getItem)(LOCALSTORAGE_KEY_ACTIVATED).then(function (activatedFromStorage) {
          (0, _helpStorage.getItem)(LOCALSTORAGE_KEY_EXPIRES).then(function (expires) {
            if (Date.now() > Number(expires)) {
              activatedFromStorage = 'false';
            }

            if (activated || activatedFromStorage === 'true') {
              _this2.setState({
                shouldReactivate: true
              });
            }
          });
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate()
    /* prevProps, prevState, snapshot */
    {
      var activated = this.props.activated;
      var _this$state = this.state,
          loaded = _this$state.loaded,
          shouldReactivate = _this$state.shouldReactivate;

      if (activated || shouldReactivate) {
        (0, _helpStorage.setItem)(LOCALSTORAGE_KEY_ACTIVATED, 'true');
        (0, _helpStorage.setItem)(LOCALSTORAGE_KEY_EXPIRES, Date.now() + expirationTimeMillis);
        this.fetchAndExecuteBundle();
      }

      if (activated && !loaded) {
        var event = new Event('help-show');
        window.dispatchEvent(event);
      }
    }
  }, {
    key: "fetchAndExecuteBundle",
    value: function fetchAndExecuteBundle() {
      var _this3 = this;

      var env = this.props.env;
      var scriptExisting = window.document.getElementById(SCRIPT_ID);

      if (!scriptExisting) {
        this.setState({
          loading: true
        });
        var script = window.document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = getApiEndpoint({
          env: env
        });
        script.async = true;
        script.defer = true;

        script.onerror = function () {
          return _this3.setState({
            error: true,
            loading: false
          });
        };

        script.onload = function () {
          return _this3.setState({
            loaded: true,
            loading: false
          });
        };

        var head = window.document.getElementsByTagName('head')[0];

        if (head) {
          head.appendChild(script);
        }
      }
    }
  }, {
    key: "fetchAndExecuteBundleChiclet",
    value: function fetchAndExecuteBundleChiclet() {
      var _this4 = this;

      var env = this.props.env;
      var scriptExisting = window.document.getElementById(SCRIPT_ID_CHICLET);

      if (!scriptExisting) {
        var script = window.document.createElement('script');
        script.id = SCRIPT_ID_CHICLET;
        script.src = getApiEndpoint({
          chiclet: true,
          env: env
        });
        script.async = true;
        script.defer = true;

        script.onerror = function () {
          return _this4.setState({
            error: true
          });
        };

        script.onload = function () {
          return _this4.setState({
            loadedChiclet: true
          });
        };

        var head = window.document.getElementsByTagName('head')[0];

        if (head) {
          head.appendChild(script);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          activated = _this$props2.activated,
          env = _this$props2.env,
          tabInitial = _this$props2.tabInitial;
      var _this$state2 = this.state,
          error = _this$state2.error,
          loaded = _this$state2.loaded,
          loading = _this$state2.loading,
          loadedChiclet = _this$state2.loadedChiclet,
          affordanceOverride = _this$state2.affordanceOverride,
          calledByChiclet = _this$state2.calledByChiclet;
      if (error) return null;

      if (activated && loading) {
        return Spinner;
      }

      if (loaded && // bundle was fetched and executed successfully
      window.HelpContainer && // executed bundle script has created module object successfully
      window.HelpContainer.HelpContainer // react component exists inside module object
      ) {
          // extract react component from module object
          var _window = window,
              HelpContainer = _window.HelpContainer.HelpContainer;
          var tabToSet = calledByChiclet ? TAB_CONTACT : tabInitial; // render react component

          return this.props.affordance ? _react.default.createElement(HelpContainer, _extends({}, this.props, {
            affordance: affordanceOverride,
            tabInitial: tabToSet
          })) : _react.default.createElement(HelpContainer, _extends({}, this.props, {
            tabInitial: tabToSet
          }));
        }

      if (loadedChiclet && window.HelpChiclet && window.HelpChiclet.Chiclet) {
        // extract react component from module object
        var _window2 = window,
            Chiclet = _window2.HelpChiclet.Chiclet; // render react component

        return _react.default.createElement(Chiclet, _extends({}, this.props, {
          bundled: true,
          onClick: function onClick() {
            _this5.setState({
              calledByChiclet: true
            });

            _this5.props.onChange({
              minimized: false
            });
          },
          onSplitResolved: function onSplitResolved(enabled) {
            return _this5.setState({
              affordanceOverride: enabled
            });
          }
        }));
      }

      return null;
    }
  }]);

  return HelpLoader;
}(_react.PureComponent);

HelpLoader.propTypes = {
  tabInitial: _propTypes.default.string,
  calledByChiclet: _propTypes.default.bool,
  visitorId: _propTypes.default.string,
  activated: _propTypes.default.bool.isRequired,
  affordance: _propTypes.default.bool.isRequired,
  env: _propTypes.default.oneOf(['local', 'dev', 'development', 'test', 'prod', 'production']).isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = HelpLoader;
exports.default = _default;